module.exports = __webpack_public_path__ + "static/media/carta_76.62c35c68.jpg";